module.exports = "<div class=\"image-effect-form\" [formGroup]=\"form\">\r\n  <atn-image-input\r\n    formControlName=\"image\"\r\n    size=\"s\"\r\n  ></atn-image-input>\r\n\r\n  <mat-form-field>\r\n    <input\r\n      matInput\r\n      formControlName=\"name\"\r\n      placeholder=\"Nombre\"\r\n    >\r\n    <atn-current-locale-code matSuffix></atn-current-locale-code>\r\n  </mat-form-field>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-image-effect-form/product-image-effect-form.component.html
// module id = ./libs/atenea-cms-brand/src/products/product-image-effect-form/product-image-effect-form.component.html
// module chunks = main